import React from "react";
import { Button } from "./styles";

const IconButton = ({
  icon,
  text,
  onClick = () => {},
  iconBackground,
  background,
  style,
  interactive = false,
  active,
  className
}) => {
  return (
    <Button
      className={`row pointer ${className}`}
      iconBackground={iconBackground}
      background={background}
      onClick={onClick}
      style={style}
      active={active}
      interactive={interactive}
    >
      <div className={`arrow-container ${interactive && "fade"}`}>
        {typeof icon === "string" || icon == null ? (
          <img
            className={`arrow-img  ${interactive && "rotate"}`}
            src={icon}
            alt="open-close"
          />
        ) : (
          <span className={`arrow-img  ${interactive && "rotate"}`}>
            {icon}
          </span>
        )}
      </div>
      <p className="p3b mr-18 ml-12 mt-3 ws-nowrap">{text}</p>
    </Button>
  );
};

export default IconButton;
